import { FC } from "react";
import { Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

export const CaseLayout: FC = () => {
  return (
    <CaseLayoutWrapper>
      <Outlet />
    </CaseLayoutWrapper>
  );
};

const CaseLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
